//設定箇所 start
var minDay = 2;//現在日時からこの数値をプラスして選択可能な最短日数 本日が1/1で設定が1なら最短は1/2
var maxListSize = 5;//最短日数から起算して選択可能な最大日数 本日が1/1で設定が10なら最大日は1/10　締め時間,不可曜日,不可日付があった場合、最大リストから除去する形になる
                     //※注意点 数値を伸ばし過ぎると閲覧者の利用端末によっては動作が重くなります 100以内に収めてください
var limitTime = "13:59"; //受注締め時間 これを跨いだ場合minDayに1日加算されます 未設定は"23:59"にする
var timezoneoffset = -9; // UTC-表示したいタイムゾーン(単位:hour) JSTなら-9
var WeekChars = [ "日", "月", "火", "水", "木", "金", "土" ];
var noSendWeekDaylist = ['','','','','']; //選択不可能な曜日 生成したリストから該当の曜日を除去して表示 ''で曜日を囲み複数ある場合はカンマで繋ぐ
//var noSendWeekDaylist = ['日','月','火','水','木','金','土']; //設定サンプル
var noSendDaylist = ['11/3','11/4','11/5','/','/','/','/','/','/','/','/','/',]; //選択不可能な日YY/MM形式で指定 生成したリストから該当の日を除去して表示 ''で日を囲み複数ある場合はカンマで繋ぐ
//var noSendDaylist = ['01/01','06/13']; //サンプル
var pullDownAddWeekDay = true;//日付選択プルダウンに曜日を追加して表示 trueなら表示falseなら非表示
var pullDownAddHead = true;//日付選択に"指定無し"を追加する trueなら表示falseなら非表示
var pullDownAddHeadtxt = "指定なし";//指定をしない際のテキスト
var pullDownAddYear = true;//日付選択に年を追加する trueなら表示falseなら非表示
//設定箇所 end


//設定したタイムゾーンに併せた現在日時を取得
var fakeUTC = new Date(Date.now() - (timezoneoffset * 60 - new Date().getTimezoneOffset()) * 60000);
var year = fakeUTC.getFullYear();
var month = fakeUTC.getMonth()+1;
var date = fakeUTC.getDate();
var hour = fakeUTC.getHours();
var min = fakeUTC.getMinutes();
var second = fakeUTC.getSeconds();


//起動
$(function() {
  var today = getToday();//現在日の取得
  var now = getNow();//現在日時の取得
  try {//配送締め時間の取得
    var deadlineHour = limitTime.split(':')[0];
    var deadlineMinute = limitTime.split(':')[1];
    var deadlineTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), deadlineHour, deadlineMinute);
  } catch(e) {
    console.log(e);
    deadlineTime = today;//指定方法に不備があった場合は現在日時が締め時間
  }
  if(now.getTime() > deadlineTime.getTime()){//締め時間を超えた場合に1日加算
    minDay++;
  }
  var mimDay = new Date(now.setDate(now.getDate() + minDay));//最短日付
  var selectList = createList(mimDay);//リストを作成
  
  if(noSendWeekDaylist.length > 0){//曜日の選択があればリストから削除
    selectList = delSendWeekDay(selectList);
  }
  if(noSendDaylist.length > 0){//日付の指定があればリストから削除
    selectList = delSendDay(selectList);
  }
  createPullDown(selectList);
  
})

//リストから指定の曜日を除去する
function delSendWeekDay(selectList){
 var delAfterList = [];
 var skipFlg=false;//初期値
 for (var i=0; i< selectList.length; i++) {
  skipFlg=false;//初期化
  var wDay= selectList[i].getDay();//曜日の取得
   WeekChars[wDay];
   for(var j=0; j< noSendWeekDaylist.length; j++){
      if(WeekChars[wDay] == noSendWeekDaylist[j]){
        skipFlg=true;
      }
   }
   if(!skipFlg){
      delAfterList.push(selectList[i]);
   }
 }
  return delAfterList;
 }

//リストから指定日付の除去
function delSendDay(selectList){
  var delAfterList = [];
  var noSendDay;
  var targetDay;
  var skipFlg=false;
  for (var i=0; i< selectList.length; i++) {
    skipFlg=false;
    targetDay = new Date(selectList[i].getMonth()+1+'/'+selectList[i].getDate());
    for(var j=0; j< noSendDaylist.length; j++){
      noSendDay = new Date(noSendDaylist[j]);
      if(targetDay.getTime() == noSendDay.getTime()){
          skipFlg=true;
      }
    }
    if(!skipFlg){
      delAfterList.push(selectList[i]);
    }
  }
  return delAfterList;
}

//基本日付リストの作成
function createList(minDay){
  var selectList = [];
  var targetDay = minDay;
  for (var i=0; i< maxListSize; i++) {
   targetDay = new Date(minDay);
   targetDay = new Date(targetDay.setDate(targetDay.getDate() + i));
   selectList.push(targetDay);
  }
  return selectList;
}

//現在日の取得(タイムゾーンで指定された日)
function getToday(){
  var today = new Date(year+"/"+month+"/"+date);
  return today;
}

//現在日時の取得(タイムゾーンで指定された時間)
function getNow(){
  var now = new Date(year+"/"+month+"/"+date+" "+hour+":"+min);
  return now;
}

//プルダウンに曜日追加
function pullDownAddWeekDay(){
  //曜日追加
  var w = ["日","月","火","水","木","金","土"];
  var deliveryDateSelectOption = $('select#SEND_HOPE_DATE option');
  for (var i=0; i<=deliveryDateSelectOption.length; i++) {
      if(i!=0){
          var optDatext = $(deliveryDateSelectOption[i]);
          var optionDateWeekDay = new Date($(optDatext).text());
          var optionDateWeekDayW = w[optionDateWeekDay.getDay()];
          $(optDatext).text( $(optDatext).text()+" ("+optionDateWeekDayW+")");
          }
      }
}

//プルダウンの作成
function createPullDown(selectList){
  var targetDate;
  var wDay='';
  var targetWeekDay = '';    
  var select = document.getElementById('deliveryDate');
  var option = document.createElement('option');
  if(pullDownAddHead){//指定なし
    option.setAttribute('value', '');
    option.innerHTML = pullDownAddHeadtxt;
    select.appendChild(option);
  }
  for(var i=0; i< selectList.length; i++){
    option = document.createElement('option');
    targetDate='';
    targetWeekDay='';
    targetDate = ketaume((selectList[i].getMonth()+1),2)+'-'+ ketaume(selectList[i].getDate(),2);
    option.setAttribute('value', selectList[i].getFullYear()+'-'+targetDate);//valueをセット yyyy-mm-dd形式
    targetDate=targetDate.replace(/-/g,'/');
     if(pullDownAddYear){//年を追加する場合
      targetDate = selectList[i].getFullYear()+'/'+targetDate;
    }
    if(pullDownAddWeekDay){//曜日を追加する場合
      wDay= selectList[i].getDay();
      targetDate=targetDate+" ("+WeekChars[wDay]+")";
    }
    option.innerHTML = targetDate;
    select.appendChild(option);
    
  }
  
}
//桁埋めを行う
function ketaume(num,digit){
  if(digit < 1)
      return num; 
  var ketaumeStr = '0';
  var zero = '';
  
  for(var i=1; i<digit; i++){
      zero += ketaumeStr;
  }
  var result = ( zero + num ).slice( -digit );
  return result;
}